import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { AddQuestionAttemptsTrackingCommand, AddQuestionAttemptsTrackingCommandPayload } from '../api'
import { QuestionAttemptsSuspendDataStore } from '../common';

const debug = Debug('scorm2004-add-question-attempts-command-handler')

@injectable()
export class Scorm2004AddQuestionAttemptsCommandHandler implements CommandHandler<AddQuestionAttemptsTrackingCommand> {

  constructor (
    @inject(QuestionAttemptsSuspendDataStore)
    private store: QuestionAttemptsSuspendDataStore,
  ) {}
  
  public async execute(command: AddQuestionAttemptsTrackingCommandPayload) {

    debug('execute', command)

    await this.store.execute(createCommand<AddQuestionAttemptsTrackingCommand>('add-question-attempts', command))
  }
}
